import { render, staticRenderFns } from "./subTitle.vue?vue&type=template&id=44c3a6a6&scoped=true&"
import script from "./subTitle.vue?vue&type=script&lang=js&"
export * from "./subTitle.vue?vue&type=script&lang=js&"
import style0 from "./subTitle.vue?vue&type=style&index=0&id=44c3a6a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c3a6a6",
  null
  
)

export default component.exports